<template>
  <v-app>
    <d-header
      v-model="drawer"
      title="Estadísticas de resultados PAES - Unidades educativas"
      :logged="false"
      :show-side-icon="true"
    />
    <v-main>
      <v-container>
        <v-card flat class="mt-4">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6">
                <v-select
                  v-model.number="regCodigo"
                  :items="regiones"
                  label="(*) Región"
                  item-text="regNombre"
                  item-value="regCodigo"
                  placeholder="Región"
                  hint="Seleccione región"
                  persistent-hint
                  dense
                  @change="ueds = []; search = null"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model.number="comCodigo"
                  :items="comunasByRegion"
                  label="(*) Comuna"
                  item-text="cNom"
                  item-value="cCod"
                  placeholder="Comuna"
                  hint="Seleccione una comuna"
                  persistent-hint
                  dense
                  @change="search = null"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card flat>
          <v-card-title>
            Unidades educativas por comuna
            <v-spacer />
            <v-text-field
              v-model="search"
              append-outer-icon="search"
              label="Buscar establecimientos"
              single-line
              dense
            />
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-data-table
                  :headers="headers"
                  :items="ueds"
                  :search="search"
                  class="elevation-1"
                  no-data-text="No existe información de establecimientos"
                  :loading="loadData"
                  loading-text="Cargando información"
                  fixed-header
                >
                  <template #item.url="{ item }">
                    <v-hover v-slot="{ hover }">
                      <v-btn
                        fab
                        dark
                        x-small
                        :elevation="hover ? 10 : 2"
                        color="primary"
                        :disabled="!loadFile[item.rbd] && disableBtn"
                        :loading="loadFile[item.rbd]"
                        @click="download(item.rbd)"
                      >
                        <v-icon dark>
                          cloud_download
                        </v-icon>
                      </v-btn>
                    </v-hover>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
      <d-notifier />
    </v-main>
  </v-app>
</template>

<script>
import Header from '@demre/client-common/src/components/header';
import regionesJson from '../../assets/json/regiones.json';
import comunasJson from '../../assets/json/comunas.json';
import Notifier from '@demre/client-common/src/components/notifier';
import {getGtoken} from '../../utils/utils';

export default {
  components: {
    'd-header': Header,
    'd-notifier': Notifier,
  },
  data: function () {
    return {
      drawer: true,
      lista: [],
      loadData: false,
      search: '',
      regCodigo: null,
      comunasByRegion: [],
      comCodigo: null,
      ueds: [],
      loadFile: {},
      disableBtn: false,
    }
  },
  computed: {
    headers() {
      return [
        { text: 'RBD', value: 'rbd' },
        { text: 'NOMBRE ESTABLECIMIENTO', value: 'nombre' },
        { text: 'RAMA EDUCACIONAL', value: 'rama' },
        { text: 'DESCARGAR', value: 'url', align:'center', sortable: false },
      ];
    },
    regiones() {
      return regionesJson['regiones'];
    },
    comunasAll() {
      return comunasJson['comunas'];
    },
    recaptchaPublicKey() {
      return process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY;
    }
  },
  watch: {
    regCodigo(val) {
      this.comunasByRegion = this.comunasAll.filter(c => c.rCod == val);
    },
    comCodigo() {
      this.uedsByComuna();
    }
  },
  mounted() {
    const scriptTag = document.createElement('script');
    scriptTag.src =`https://www.google.com/recaptcha/api.js?render=${this.recaptchaPublicKey}`;
    document.getElementsByTagName('head')[0].appendChild(scriptTag);
  },
  methods: {
    async uedsByComuna() {
      this.loadData = true;
      try {
        const gToken = await getGtoken(this.recaptchaPublicKey, 'search')
        const url = `${process.env.VUE_APP_SERVER_HOST}/api/ueds/${this.regCodigo}/${this.comCodigo}/${gToken}`;
        const req = await fetch(url, { method: 'GET'});
        const response = await req.json();
        if (Object.keys(response).includes('error')) {
          throw new Error(response.error);
        }
        this.ueds = response.ueds.map(u => (
          {
            rbd: `${u.rbd}-${u.codEns}`,
            nombre: u.uedNombre,
            rama: u.ramaEducacional.nombre,
          }
        ));
      } catch (err) {
        this.$store.commit("error-notification", err.message);
      }
      this.loadData = false;
    },
    async download(rbd) {
      this.$set(this.loadFile, rbd, true);
      this.disableBtn = true;
      try {
        const gToken = await getGtoken(this.recaptchaPublicKey, 'download')
        const url = `${process.env.VUE_APP_SERVER_HOST}/api/estadisticas/url/${rbd}/${gToken}`;
        const req = await fetch(url, { method: 'GET'});
        const response = await req.json();
        if (Object.keys(response).includes('error')) {
          throw new Error(response.error);
        }
        window.open(response.url, '_blank');
      } catch (err) {
        this.$store.commit("error-notification", err.message);
      }
      this.disableBtn = false;
      this.loadFile[rbd] = false;
    },
  }
}
</script>
